/**
 * Reads CSS custom properties from the document root.
 *
 * @param {Element} root
 */
export function createTheme(root = document.documentElement) {
  const styles = getComputedStyle(root);

  return {
    color(name) {
      return styles.getPropertyValue(name).trim();
    },
  };
}
